const CUSTOMER_TRANSFER_FEE_RATE_WITH_AD = 0.66

// anybody(ADあり)
// 送客手数料率(税込) = 0.66
export function calcCustomerTransferFeeRateWithAD(): number {
  return CUSTOMER_TRANSFER_FEE_RATE_WITH_AD
}

const CUSTOMER_TRANSFER_FEE_RATE_WITHOUT_AD = 0.33
// anybody(ADなし)
// 送客手数料率(税込) = 0.33
export function calcCustomerTransferFeeRateWithoutAD(): number {
  return CUSTOMER_TRANSFER_FEE_RATE_WITHOUT_AD
}
